module.exports = __webpack_public_path__ + "static/media/Hero_JVEquity.05ca64c9.jpg";